import ForWhomItem from "./for-whom-item";
export default ForWhomItem;